export default from './report-member-modal';



// WEBPACK FOOTER //
// ./app/containers/report-member-modal/index.js